var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('verka-public-grid',[_c('template',{slot:"public-grid-content"},[_c('verka-contact-form',{attrs:{"termsAndConditions":"true","publicContact":"true"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }